import React from "react";

export default function StepThree(props){
  const inputValues = props.inputValues
  const stepThreeQuestions = [
    'Do you need to be instantly notified about changes in your local market?',
    'Would you like the ability to export property data and attributes for offline analysis and filtering?',
    'Would you like to create branded, interactive and customisable digital listing kits, pre-list kits and rental proposals or create interactive digital property reports for your clients?'
  ]

  const stepThreeInputNames = [
    'notify',
    'dataExports',
    'digitalProposals'
  ]

  let classNames = require('classnames');
  let headingClass = classNames({
    'col-sm-12 padding-top-15 padding-bottom-15 text-align-left body': !props.mobile,
    'col-sm-12 padding-10-0 text-align-left body': props.mobile
  });
  let rowClass = classNames({
    'row': !props.mobile,
    'row no-margin': props.mobile
  });

  return(
    <React.Fragment>
      <div className="step-breadcrumb hmcw-h5">Step 3 of 3</div>
      <div className="flex-justified padding-30-0">
        <div className="hmcw-h3" style={{textAlign:'left'}}>Tell me about your business</div>
      </div>
      {stepThreeQuestions.map((question, i) => {
        return (
          <div className="form-group" key={`step-three-question-${i}`}>
          <div className={rowClass}>
            <div className={headingClass}>{question}</div>
            <div className="col-xs-6 wizard-form-text body">
              <label className="wizard-form-radio">
                <input
                  type="radio"
                  name={stepThreeInputNames[i]}
                  value="Yes"
                  checked={inputValues[stepThreeInputNames[i]].value === "Yes"}
                  onChange={props.handleChange} />
                Yes
              </label>
            </div>
            <div className="col-xs-6 wizard-form-text body">
              <label className="wizard-form-radio">
                <input
                  type="radio"
                  name={stepThreeInputNames[i]}
                  value="No"
                  checked={inputValues[stepThreeInputNames[i]].value === "No"}
                  onChange={props.handleChange} />
                No
              </label>
            </div>
          </div>
          {
            inputValues[stepThreeInputNames[i]].error &&
            <div className="red-text footnote-text hmcw-error-msg">Please answer yes or no this question.</div>
          }
          </div>
        )
      })}
    </React.Fragment>
  );
}
